const notify = {
    state: {
        notifyCount: {
            toMySignCount: 0,
            toMyOutgoingCount: 0,
            toPackageSignCount: 0,
            toSignCount: 0,
            billCount: 0,
            billCountBack: 0,
            billCountSign: 0,
            toOutgoingCount: 0,
            toOutgoingLocalCount: 0,
            toSignLocalCount: 0,
            toErrorCount:0,
            orderErrorCount: 0,
            expressBackCount:0
        }
    },
    mutations: {
        SET_COUNT: (state, params) => {
            state.notifyCount = params;
        }
    },
    actions: {
        setCount({ commit }, obj) {
            commit('SET_COUNT', obj)
        }
    }
}
export default notify